import * as Layout from 'src/applications/Embed/elements/LayoutElements'
import { FooterButton } from 'src/applications/Embed/fragments/Footer'
import { EmbedLayout } from 'src/applications/Embed/fragments/Layout'
import { IScenePayload } from 'src/applications/Embed/types/IScene'
import { HeaderRowSelectionPanel } from 'src/applications/Oversight/panels/HeaderRowSelectionPanel'
import { FlexEndFooter } from 'src/applications/Embed/elements/SceneElements'
import { useTranslation } from 'react-i18next'

export const HeaderRowSelectionScene = ({ batch, onComplete, onCancelBatch }: IScenePayload) => {
  const { t } = useTranslation()
  return (
    <EmbedLayout hasFooter>
      <Layout.FullContent>
        <Layout.FlexVertical>
          <HeaderRowSelectionPanel
            dataSourceIndex={batch.dataSourceIndex}
            schemaId={parseInt(batch.schemaId, 10)}
            uploadId={batch.uploadId}
            renderConfirm={(submit) => (
              <FlexEndFooter boxShadow>
                <FooterButton onClick={submit} embeds={true}>
                  {t('elements.buttons.continue')}
                </FooterButton>
              </FlexEndFooter>
            )}
            onReset={onCancelBatch}
            onComplete={() => onComplete()}
            fullScreen
          />
        </Layout.FlexVertical>
      </Layout.FullContent>
    </EmbedLayout>
  )
}
